import { API_FIELDS_CONTACT as CONTACT } from '@enroller/admissions-components';

export const STUDENT_FIELDS = `
  ${CONTACT.firstName} { value }
  ${CONTACT.lastName} { value }
  ${CONTACT.preferredName} { value }
  ${CONTACT.gender} { value }
  ${CONTACT.cityOfBirth} { value }
  ${CONTACT.countryOfBirth} { value }
  ${CONTACT.dateOfBirth} { value }
  ${CONTACT.citizenship} { value }
  ${CONTACT.residence} { value }
  ${CONTACT.email} { value }
  ${CONTACT.mobile} { value }
  ${CONTACT.homePhone} { value }
  ${CONTACT.emergencyContactRelation} { value }
  ${CONTACT.emergencyContactPhoneNumber} { value }
  ${CONTACT.emergencyContactName} { value }
  ${CONTACT.country} { value }
  ${CONTACT.city} { value }
  ${CONTACT.addressLine2} { value }
  ${CONTACT.postalCode} { value }
  ${CONTACT.addressLine1} { value }
`;
